export default __webpack_public_path__ + "static/media/ImageCode.311bd6af.jpg";